import React from 'react';
import PageHero from '../components/PageHero';
// import AdBanner from '../components/AdBanner';

const FAQ = () => (
  <main className="bg-surface">
    <PageHero title="FAQ" />
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <div>
        <h2 className="text-xl font-semibold">What is a lithophane?</h2>
        <p className="text-gray-700">
          A lithophane is a thin 3D-printed panel that reveals an image when backlit.
          The varying thickness of the print controls how much light shines through,
          creating a glowing photo.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold">How long does production take?</h2>
        <p className="text-gray-700">
          Orders are typically printed and shipped within 5-7 business days.
          You'll receive tracking information as soon as your lamp is on the way.
        </p>
      </div>

      <div>
        <h2 className="text-xl font-semibold">Can I use any photo?</h2>
        <p className="text-gray-700">
          High-contrast images work best. You can upload JPG or PNG files directly
          into the builder to preview the result.
        </p>
      </div>

      {/* <AdBanner /> */}
    </div>
  </main>
);

export default FAQ;